// ----- IMPORTS -----

import { log, get, getAll } from "./utils.js";

import Splide from '@splidejs/splide';
import Swup from "swup";
import "netlify-identity-widget";
import { init } from "netlify-identity-widget";


// init swup
const swup = new Swup({
  // options
  plugins: [],
});

let page

const checkPath = (callback) => {
  const path = window.location.pathname;
  const length = path.split("/").length;

  if (path.includes("/cv/")) {
    page = "cv";
  } else if (path.includes("/imprint/")) {
    page = "imprint";
  } else if ((path.includes("/projects/") || path.includes("/projektek/") || path.includes("/projekte/")) && length == 4) {
    page = "projects";
  } else if ((path.includes("/projects/") || path.includes("/projektek/") || path.includes("/projekte/")) && length == 5) {
    page = "project";
  } else if (path === "/en/" || path === "/de/" || path === "/hu/") {
    page = "home";
  }

  callback()
}

const initListeners = () => {
  if (page === "home") {

    // init splide
    new Splide('.splide', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
      autoplay: true,
      interval: 5000,
      speed: 1000,
    }).mount();

  } else if (page === "project") {

    

  } else if (page === "projects") {

    // highlight active sidebar element
    const sidebarElems = getAll(".projectsSidebarElem");
    const headerHeight = get("header").offsetHeight;
    const viewportHeight = window.innerHeight;

    const highlightActiveSidebarElem = () => {
      sidebarElems.forEach((item) => {
        const projectSlug = item.getAttribute("data-project-slug");
        const projectElement = get(`.projectElem[data-project-slug="${projectSlug}"]`);

        if (projectElement) {
          if (!projectElement.classList.contains("hidden")) {

            if (projectElement.getBoundingClientRect().top - headerHeight <= viewportHeight / 2) {
              sidebarElems.forEach((item) => {
                item.classList.remove("active");
              });

              item.classList.add("active");
            }

          }
        }
      });
    }

    // hide filters that don't have any projects
    const hideEmptyFilters = () => {
      const projectFilters = getAll(".projectFilter");
      const projectElems = getAll(".projectElem");

      projectFilters.forEach((filter) => {
        const filterValue = filter.getAttribute("data-filter");

        if (filterValue !== "projects") {
          const projects = [...projectElems].filter((elem) => elem.getAttribute("data-filter").includes(filterValue));

          if (projects.length === 0) {
            filter.style.display = "none";
          }
        }
      });
    }

    // initial check
    highlightActiveSidebarElem();
    hideEmptyFilters();

    // check on scroll
    window.addEventListener("scroll", () => {
      highlightActiveSidebarElem();
    });

    // filter projects by category
    const projectFilters = getAll(".projectFilter");
    const projectElems = getAll(".projectElem");

    projectFilters.forEach((filter) => {
      filter.addEventListener("click", () => {
        const filterValue = filter.getAttribute("data-filter");

        // filter the projects
        projectElems.forEach((elem) => {
          if (filterValue === "projects") {
            elem.style.display = "block";
            elem.classList.remove("hidden");
          } else if (elem.getAttribute("data-filter").includes(filterValue)) {
            elem.style.display = "block";
            elem.classList.remove("hidden");
          } else {
            elem.style.display = "none";
            elem.classList.add("hidden");
          }
        });

        // hide the sidebar elements of the hidden projects
        sidebarElems.forEach((elem) => {
          elem.classList.remove("active");

          if (filterValue === "projects") {
            elem.style.display = "block";
          } else if (elem.getAttribute("data-filter").includes(filterValue)) {
            elem.style.display = "block";
          } else {
            elem.style.display = "none";
          }
        })

        // underline the active filter
        projectFilters.forEach((filter) => {
          filter.classList.remove("active");
        })

        filter.classList.add("active")

        // re-check the active sidebar element
        highlightActiveSidebarElem();
      });
    }
    );
  }

  // hide/show header on scroll
  const header = get("header");
  const projectsSidebar = get(".projectsSidebar");
  let lastScrollTop = 0;
  const threshold = 20;
  const minScroll = 100;

  window.addEventListener("scroll", function () {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    let scrollDifference = Math.abs(scrollTop - lastScrollTop);

    if (scrollTop > minScroll && scrollDifference > threshold && window.innerWidth > 1000) {
      if (scrollTop > lastScrollTop) {
        header.style.transform = "translateY(-100%)";
        if (projectsSidebar) {
          projectsSidebar.classList.add("scrolled");
        }
      } else {
        header.style.transform = "translateY(0)";
        if (projectsSidebar) {
          projectsSidebar.classList.remove("scrolled");
        }
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
  }, { passive: true });


  // mobile menu
  const hamburgerButton = get('.hamburgerButton')
  const body = get('.body')

  hamburgerButton.addEventListener('click', () => {
    body.classList.toggle("mobileMenuActive")
  })

  get('.mobileMenuElems').addEventListener('click', () => {
    body.classList.remove("mobileMenuActive")
  })
}


document.addEventListener("DOMContentLoaded", function () {
  // first load
  checkPath(initListeners)

  // swup page load (all loads but the first)
  swup.hooks.on('page:view', (visit) => {
    checkPath(initListeners)
  });
});


// ----- NETLIFY & DECAP CMS -----

// netlify identity widget
const netlifyIdentity = () => {
  if (window.netlifyIdentity) {
    window.netlifyIdentity.on("init", (user) => {
      if (!user) {
        window.netlifyIdentity.on("login", () => {
          document.location.href = "/admin/";
        });
      }
    });
  }
};

netlifyIdentity();